export const COMMENT_MIN_LENGTH = 1;
export const COMMENT_MAX_LENGTH = 500;
